import React from 'react';
import IconBase from './shared/icon-base';
import { jsx as ___EmotionJSX } from "@emotion/core";
export default function EerIcon(props) {
  return ___EmotionJSX(IconBase, props, ___EmotionJSX("path", {
    d: "M5 14.8H8.87793V13.8445H6.08948V12.4269H8.59604V11.4792H6.08948V10.1555H8.8246V9.20001H5V14.8Z",
    fill: "currentColor"
  }), ___EmotionJSX("path", {
    d: "M9.82866 14.8H13.7066V13.8445H10.9181V12.4269H13.4247V11.4792H10.9181V10.1555H13.6533V9.20001H9.82866V14.8Z",
    fill: "currentColor"
  }), ___EmotionJSX("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5677 12.419L19 14.8H17.7353L16.402 12.4974H15.7468V14.8H14.6573V9.20784H16.7677C18.0781 9.20784 18.7029 9.84225 18.7029 10.8213C18.7105 11.6906 18.1696 12.2232 17.5677 12.419ZM16.722 10.132H15.7468V11.5575H16.7144C17.2934 11.5575 17.6058 11.3225 17.6058 10.8213C17.6058 10.3513 17.2782 10.132 16.722 10.132Z",
    fill: "currentColor"
  }), ___EmotionJSX("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 2C21.6543 2 23 3.3457 23 5V19C23 20.6543 21.6543 22 20 22H4C2.3457 22 1 20.6543 1 19V5C1 3.3457 2.3457 2 4 2H20ZM20 4C20.5518 4 21 4.44824 21 5V19C21 19.5518 20.5518 20 20 20H4C3.44824 20 3 19.5518 3 19V5C3 4.44824 3.44824 4 4 4H20Z",
    fill: "currentColor"
  }));
}